import { styled } from '@mui/material'

export const RequiredStar = styled('span')(() => ({
  color: 'red',
}))
